<template>
    <div>

        <q-dialog position="right" v-model="dialog" content-class="dialog-content">
            <q-card style="min-width: 400px;">
                <h4 class="mt-0 mb-3 text-left q-pa-md" style="font-size: 26px; font-weight: 300">
                    Export Retail Sales
                </h4>
                <q-card-section style="min-height: 30vh;">
                    <q-form class="q-pa-md d-flex" ref="form">
                        <div class="row">
                            <div class="col-12">
                                <q-radio label="ESET" v-model="oemId" :val="Constants.OEMId.ESET"/>
                                <q-radio label="FORTINET" v-model="oemId" :val="Constants.OEMId.FORTINET"/>
                            </div>
                            <div class="col-12">
                                <date-range-picker appendToBody opens="left" :autoApply="true" class="w-100" ref="picker" v-model="dateRange">
                                    <div class="searchBox d-flex py-3 w-100" slot="input" slot-scope="picker" style="align-items: center">
                                        <i class="material-icons mr-1" style="font-size: 16px"> date_range </i>
                                        {{ picker.startDate|dateFilter }} - {{ picker.endDate|dateFilter }}
                                    </div>
                                </date-range-picker>
                            </div>
                        </div>
                    </q-form>
                </q-card-section>
                <q-card-actions class="q-pa-lg">
                    <q-btn label="EXPORT" @click="exportData" class="pd-btn ml-2 mr-2"/>
                    <q-btn label="CANCEL" @click="closeDialog" color="grey" />
                </q-card-actions>
            </q-card>
        </q-dialog>

    </div>
</template>

<script>
import Constants, {OEMIdToOrderType} from "../../Constants/Constant";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'

export default {
    name: "ExportRetailSales",
    props: ['exportDialog'],
    components: { DateRangePicker },
    data: function(){
        return{
            Constants: Constants,
            userObj: JSON.parse(localStorage.getItem('user')),
            oemId: Constants.OEMId.ESET,
            dateRange: {
                startDate: moment().subtract(31, 'days').format('YYYY-MM-DD'),
                endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            },
        }
    },
    computed:{
        dialog: {
            get: function () { return this.exportDialog },
            set: function (value) { this.$emit('update:exportDialog', value) },
        },
    },
    methods:{
        exportData() {
            let orderType = OEMIdToOrderType[this.oemId]
            let startDate = moment(this.dateRange.startDate).format('YYYY/MM/DD')
            let endDate = moment(this.dateRange.endDate).format('YYYY/MM/DD')
            this.closeDialog()
            window.open(`${Constants.api_url}partnerRetailSalesExport/${this.userObj.orgId}/${orderType}?startDate=${startDate}&endDate=${endDate}`, '_blank')
        },
        closeDialog(){
            this.$emit('update:exportDialog', false)
        }
    }
}
</script>

<style scoped>
/deep/ .reportrange-text {
    border: none !important;
    padding: 0 !important;
}
</style>
<style>
.dialog-content{
    z-index: 3000 !important; /* To show date-picker on top of it */
}
</style>